import {useContext} from 'react'

import {StateContext, DispatchContext} from '../contexts'

export const connect = (mapStateToProps, actionCreators) => WrappedComponent => {
  const Component = props => {
    const state = useContext(StateContext)
    const dispatchs = useContext(DispatchContext)
    let data = {}

    if (mapStateToProps)
      data = {...data, ...mapStateToProps(state, props)}

    if (actionCreators)
      data = {...data, ...actionCreators(dispatchs)}

    return <WrappedComponent {...props} {...data} />
  }

  return Component
}
